import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleArrowRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm3.78,8.53l-2.5,2.5c-.146,.146-.338,.22-.53,.22s-.384-.073-.53-.22c-.293-.293-.293-.768,0-1.061l1.22-1.22H5.75c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h4.689l-1.22-1.22c-.293-.293-.293-.768,0-1.061s.768-.293,1.061,0l2.5,2.5c.293,.293,.293,.768,0,1.061Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleArrowRightFill18.js.map